<div class="row">
  <div class="col">
    <h4 class="page-title">
      <button class="btn btn-outline-blue btn-rounded" type="button" (click)="voltar()">
        <i class="fa fa-arrow-left ct-point"></i>
      </button>
      &nbsp; <i class="fas fa-bullhorn"></i> Campanha por Template
    </h4>

    <ng-container *ngIf="carregandoTela">
      <div class="k-i-loading ml-1 mr-1 mt-4" style="font-size: 40px;"></div>
    </ng-container>

    <div *ngIf="campanha.status === 'Enviando'">
      <app-gerenciador-envio-campanha [campanha]="campanha" [titulo]="'Sua campanha por template está sendo enviada'"></app-gerenciador-envio-campanha>
    </div>

    <form *ngIf="!carregandoTela" #frmCampanha="ngForm" class="template-campaign-form" novalidate>
      <div class="template-layout">
        <main class="template-main">
          <section class="card">
            <div class="card-body">
              <div class="form-group mb-3">
                <label for="nome">Nome da Campanha</label>
                <input type="text" class="form-control" autocomplete="off"
                       id="nome" name="nome" [(ngModel)]="campanha.nome" #nome="ngModel"
                       placeholder="Ex: Reengajamento clientes de maio" required>
                <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && nome.errors?.required">
                  Nome é obrigatório
                </div>
              </div>

              <div class="form-group mb-2">
                <label for="template">Template aprovado</label>
                <kendo-combobox id="template" name="template" class="form-control template-combo"
                                [data]="templatesFiltrados"
                                [textField]="'nomeTemplate'"
                                [valueField]="'id'"
                                [filterable]="true"
                                [placeholder]="'Pesquisar template aprovado...'"
                                [(ngModel)]="templateSelecionado"
                                (filterChange)="filtreTemplates($event)"
                                (ngModelChange)="mudouTemplate()">
                  <ng-template kendoComboBoxItemTemplate let-dataItem>
                    <div class="template-option">
                      <div class="template-option-header">
                        <strong>{{dataItem.nomeTemplate}}</strong>
                        <span class="badge badge-primary" *ngIf="dataItem.templateFacebook">Facebook</span>
                        <span class="badge badge-secondary" *ngIf="dataItem.templateSistema">Sistema</span>
                        <span class="badge badge-success">Aprovado</span>
                        <span class="badge badge-info">Marketing</span>
                      </div>
                      <div class="template-option-message">{{dataItem.textoMensagem}}</div>
                      <div class="template-option-cta" *ngIf="dataItem.botoes?.length">
                        CTA: {{dataItem.botoes[0].text || dataItem.botoes[0].value || 'Botão do template'}}
                      </div>
                    </div>
                  </ng-template>
                  <ng-template kendoComboBoxValueTemplate let-dataItem>
                    <span *ngIf="dataItem">{{dataItem.nomeTemplate}}</span>
                  </ng-template>
                </kendo-combobox>
              </div>

              <div class="template-preview" *ngIf="templateSelecionado">
                <div class="template-preview-title">
                  <i class="fab fa-whatsapp"></i> Prévia completa do template
                </div>
                <div class="template-preview-header" *ngIf="templateSelecionado.headerText">
                  {{templateSelecionado.headerText}}
                </div>
                <div class="template-preview-body">{{templateSelecionado.textoMensagem}}</div>
                <div class="template-preview-buttons" *ngIf="templateSelecionado.botoes?.length">
                  <span *ngFor="let botao of templateSelecionado.botoes" class="template-preview-button">
                    {{botao.text || botao.value || 'CTA'}}
                  </span>
                </div>
              </div>
            </div>
          </section>

          <section class="card">
            <div class="card-body">
              <h5 class="mb-3">Contatos</h5>

              <div class="form-group mb-3">
                <label>Lista de Contatos</label>
                <div class="mt-1 mb-1 contact-source-options">
                  <label class="k-radio-label mr-1" for="origemContatos1">
                    <input type="radio" #origemContatos="ngModel" name="origemContatos" id="origemContatos1"
                           class="k-radio right" kendoRadioButton value="Filtro"
                           [(ngModel)]="campanha.origemContatos" required (ngModelChange)="mudouOrigemContatos()"/>
                    De um Filtro
                  </label>
                  <label class="k-radio-label" for="origemContatos2">
                    <input type="radio" #origemContatos="ngModel" name="origemContatos" id="origemContatos2"
                           class="k-radio right ml-2" kendoRadioButton value="Arquivo"
                           [(ngModel)]="campanha.origemContatos" required (ngModelChange)="mudouOrigemContatos()"/>
                    Arquivo de Contatos
                  </label>
                  <label class="k-radio-label" for="origemContatos3">
                    <input type="radio" #origemContatos="ngModel" name="origemContatos" id="origemContatos3"
                           class="k-radio right ml-2" kendoRadioButton value="Todos"
                           [(ngModel)]="campanha.origemContatos" required (ngModelChange)="mudouOrigemContatos()"/>
                    Todos
                  </label>
                </div>
              </div>

              <div *ngIf="campanha.origemContatos === 'Filtro'">
                <div class="form-group mb-3">
                  <label for="filtro">Filtro</label>
                  <kendo-combobox id="filtro" name="filtro" [(ngModel)]="campanha.filtro" [data]="filtros"
                                  class="form-control" [placeholder]="'Selecione um filtro'"
                                  #filtro="ngModel"
                                  [textField]="'nome'" [valueField]="'id'"
                                  [kendoDropDownFilter]="filterSettings" required
                                  (ngModelChange)="filtreContatos()">
                  </kendo-combobox>
                  <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && filtro.errors?.required">
                    Filtro é obrigatório
                  </div>
                </div>
              </div>

              <div [hidden]="campanha.origemContatos !== 'Arquivo'">
                <app-upload-contatos-campanha #uploadContatos [campanha]="campanha" (onNovosContatos)="usuarioFezUploadContatos($event)" required></app-upload-contatos-campanha>
                <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && campanha.origemContatos === 'Arquivo' && erroContatosObrigatorios()">
                  Envie um arquivo com contatos
                </div>
                <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && arquivoSelecionadoSemContatosValidos()">
                  O arquivo foi selecionado, mas nenhum contato válido foi encontrado.
                </div>
              </div>

              <div class="contact-options">
                <div class="form-group mb-2">
                  <label>Deseja limitar quantidade de contatos?</label>
                  <div class="mt-1 mb-1">
                    <label class="k-radio-label" for="limitarQtdeMensagensSim">
                      <input type="radio" name="configQtdeMsgs" id="limitarQtdeMensagensSim"
                             class="k-radio right ml-2" [value]="true" [(ngModel)]="campanha.limitarQtdeContatos"
                             (click)="mudouQtdeMensagensAEnviar()" kendoRadioButton />
                      Sim
                    </label>
                    <label class="k-radio-label" for="limitarQtdeMensagensNao">
                      <input type="radio" name="configQtdeMsgs" id="limitarQtdeMensagensNao"
                             class="k-radio right ml-2" [value]="false" kendoRadioButton
                             [(ngModel)]="campanha.limitarQtdeContatos" (click)="mudouQtdeMensagensAEnviar()" />
                      Não
                    </label>
                  </div>
                </div>

                <div class="form-group mb-2" *ngIf="campanha.limitarQtdeContatos">
                  <label for="qtdeMensagens">Quantidade de contatos</label>
                  <input type="number" class="form-control" autocomplete="off"
                         id="qtdeMensagens" name="qtdeMensagens" [(ngModel)]="campanha.qtdeContatosEnviarMsg"
                         #qtdeMensagens="ngModel"
                         (ngModelChange)="mudouQtdeMensagensAEnviar()" required min="1">
                  <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && qtdeMensagens.invalid">
                    Informe uma quantidade válida
                  </div>
                </div>

                <div class="form-group mb-2 escolher">
                  <label class="mt-2 k-checkbox-label">
                    <input type="checkbox" id="naoEnviarRecente" name="naoEnviarRecente" class="k-checkbox" kendoCheckBox
                           [(ngModel)]="campanha.naoEnviarMsgParaQuemRecebeuRecente" (ngModelChange)="mudouQtdeMensagensAEnviar()" />
                    Não enviar para quem recebeu campanha recente
                  </label>
                </div>

                <div class="form-group mb-2" *ngIf="campanha.naoEnviarMsgParaQuemRecebeuRecente">
                  <label for="qtdeDiasUltimaNotificacao">Dias desde a última campanha</label>
                  <input type="number" class="form-control" autocomplete="off"
                         id="qtdeDiasUltimaNotificacao" name="qtdeDiasUltimaNotificacao"
                         [(ngModel)]="campanha.qtdeDiasUltimaNotificacao"
                         #qtdeDiasUltimaNotificacao="ngModel"
                         (ngModelChange)="mudouQtdeMensagensAEnviar()" required min="1">
                  <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && qtdeDiasUltimaNotificacao.invalid">
                    Informe a quantidade de dias
                  </div>
                </div>
              </div>

              <div class="contact-summary" *ngIf="!carregandoContatos && resumo !== null">
                <span>Total de contatos selecionados</span>
                <strong>{{resumo.total}}</strong>
              </div>
              <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && campanha.origemContatos === 'Todos' && erroContatosObrigatorios()">
                Não há contatos disponíveis para envio
              </div>

              <div class="k-i-loading ml-1 mr-1 p-4" style="font-size: 40px;" *ngIf="carregandoContatos"></div>

              <div class="alert alert-danger mt-3" *ngIf="mensagemErro">
                <i class="fas fa-exclamation-triangle"></i> <span [innerHTML]="mensagemErro"></span>
              </div>

              <div class="alert alert-success mt-3" *ngIf="mensagemSucesso">
                <i class="fas fa-check-circle"></i> {{mensagemSucesso}}
              </div>

              <div class="actions-row">
                <button type="button" class="btn btn-light btn-lg" [disabled]="salvando || enviando" (click)="apenasSalvar()">
                  Salvar
                  <i *ngIf="salvando" class="k-i-loading k-icon ml-1"></i>
                </button>
                <button type="button" class="btn btn-primary btn-lg" [disabled]="salvando || enviando" (click)="enviarCampanha()">
                  Enviar campanha
                  <i *ngIf="enviando" class="k-i-loading k-icon ml-1"></i>
                </button>
              </div>
            </div>
          </section>
        </main>

        <aside class="template-sidebar">
          <div class="summary-panel">
            <h5>Resumo</h5>
            <div class="summary-row">
              <span>Template</span>
              <strong>{{templateSelecionado?.nomeTemplate || '-'}}</strong>
            </div>
            <div class="summary-row">
              <span>Categoria</span>
              <strong>{{templateSelecionado?.categoria || '-'}}</strong>
            </div>
            <div class="summary-row">
              <span>Origem</span>
              <strong>{{templateSelecionado?.origemTemplate || '-'}}</strong>
            </div>
            <div class="summary-row">
              <span>Contatos</span>
              <strong>{{resumo?.total || contatos?.length || 0}}</strong>
            </div>
            <div class="summary-row">
              <span>Número Cloud</span>
              <strong>{{numeroWhatsappCampanhas?.whatsapp || empresa?.whatsapp || '-'}}</strong>
            </div>
          </div>

          <div class="phone-preview" *ngIf="templateSelecionado">
            <app-controle-previa-mensagem-whatsapp [mensagem]="obtenhaPreviewTemplate()"></app-controle-previa-mensagem-whatsapp>
          </div>
        </aside>
      </div>
    </form>
  </div>
</div>
